document.addEventListener("DOMContentLoaded", function () {
  var btnLoadMore = document.querySelector('.collection__infinite-trigger');
  function setAllEvents() {
    var productCards = document.querySelectorAll(".product-item");
    productCards.forEach(function (productCard) {
      var colorSwatches = productCard.querySelectorAll(".plp_item-options__color-swatch");
      var sizeSelectors = productCard.querySelectorAll(".plp_item-options__chip");
      var productImages = productCard.querySelectorAll(".product-item__image img");
      var optionName = productCard.querySelector(".money");
      var addToCartButton = productCard.querySelector(".product-form__cart-submit.btn");
      var colorName = productCard.querySelector(".color_picker_name");
      var selectedSize = null;
      var selectedColor = null;
      var defaultSelectedSwatch = document.querySelector(".plp_item-options__color-swatch.selected");
      if (defaultSelectedSwatch) {
        var colorDef = productCard.getAttribute('data-color');
        selectedColor = colorDef;
      }
      var defaultSelectedSize = document.querySelector(".plp_item-options__chip.selected");
      if (defaultSelectedSize) {
        var sizeDef = productCard.getAttribute('data-size');
        selectedSize = sizeDef;
      }
      sizeSelectors.forEach(function (label) {
        var sizeElect = label.getAttribute("data-size");
        var upperCaseSize = sizeElect;
        label.addEventListener("click", function () {
          sizeSelectors.forEach(function (otherLabel) {
            otherLabel.classList.remove("selected");
          });
          label.classList.add("selected");
          sizeElect = label.getAttribute("data-size");
          selectedSize = upperCaseSize;
          validateSelect(selectedSize, selectedColor);
        });
      });
      colorSwatches.forEach(function (swatch) {
        swatch.addEventListener("click", function (c) {
          var imageSrc = this.getAttribute("data-image");
          var nameOption = this.getAttribute("data-label");
          var idOption = this.getAttribute("data-product-id");
          colorName.textContent = nameOption;
          if (productImages) {
            productImages.forEach(function (prdImg) {
              setTimeout(function () {
                prdImg.setAttribute("src", imageSrc);
                prdImg.setAttribute("srcset", imageSrc);
                prdImg.setAttribute("data-srcset", imageSrc);
              }, 300);
            });
          } else {
            console.error("Product Image Not Found");
          }
          colorSwatches.forEach(function (otherLabel) {
            otherLabel.classList.remove("selected");
          });
          swatch.classList.add("selected");
          selectedColor = nameOption;
          validateSelect(selectedSize, selectedColor);
        });
      });
      function validateSelect(size, color) {
        var fullOptionSelect = productCard.querySelector("select#variant-selector");
        if (!size) {
          optionText = color;
        } else if (!color) {
          optionText = size;
        } else {
          optionText = "".concat(color, " / ").concat(size);
        }
        for (var i = 0; i < fullOptionSelect.options.length; i++) {
          if (fullOptionSelect.options[i].text.toLowerCase().includes(optionText.toLowerCase())) {
            fullOptionSelect.selectedIndex = i;
            break;
          }
        }
      }
      function enableAllSizes() {
        sizeSelectors.forEach(function (size) {
          size.disabled = false;
        });
      }
      addToCartButton.addEventListener("click", function (b) {
        var _selectedOption$optio;
        b.preventDefault();
        var selectedOption = productCard.querySelector("select#variant-selector");
        addProductToCart(selectedOption === null || selectedOption === void 0 || (_selectedOption$optio = selectedOption.options[selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.selectedIndex]) === null || _selectedOption$optio === void 0 ? void 0 : _selectedOption$optio.value);
      });
      function addProductToCart(e) {
        var addData = {
          id: e,
          quantity: 1
        };
        fetch("/cart/add.js", {
          body: JSON.stringify(addData),
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "xmlhttprequest"
          },
          method: "POST"
        }).then(function (response) {
          return response.json();
        }).then(function (data) {
          var openCartEvent = new Event("quick-cart:open");
          document.dispatchEvent(openCartEvent);
          return data;
        })["catch"](function (err) {
          console.error(err);
        });
      }
    });
  }
  var observer = new MutationObserver(function () {
    setAllEvents();
  });
  observer.observe(btnLoadMore, {
    attributes: true,
    childList: true,
    subtree: true
  });
  btnLoadMore.addEventListener('click', setAllEvents);
  setAllEvents();
});